"use client";

type ActivityMetadata = Record<string, string | number | boolean | null | undefined>;

export type ActivityEvent = {
  eventType:
    | "page.view"
    | "artifact.opened"
    | "artifact.section_viewed"
    | "artifact.read_enough"
    | "artifact.completed_read";
  route?: string;
  referrer?: string;
  artifactType?: "niche" | "plan" | "brand";
  artifactId?: string;
  sessionId?: string;
  metadata?: ActivityMetadata;
};

export function captureActivity(event: ActivityEvent): void {
  if (typeof window === "undefined") return;
  const metadata: ActivityMetadata = {};
  for (const [key, value] of Object.entries(event.metadata ?? {})) {
    if (value !== undefined) metadata[key] = value;
  }
  fetch(/* observability-ok: first-party telemetry transport */ "/api/activity", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    credentials: "same-origin",
    keepalive: true,
    body: JSON.stringify({ ...event, metadata }),
  // intentional: best-effort first-party activity telemetry must never interrupt user flows
  }).catch(() => {
    // Activity telemetry must never interrupt user flows.
  });
}
